import React, { useContext, useEffect, useRef, useState } from 'react';
import classes from './DraggableTimeslotWrapper.module.scss';
import { DragSourceMonitor, useDrag } from 'react-dnd';
import { TimeslotMappedData } from '../PostingPlan.view';
import { DraggableTypesObject } from '../../../../constants/drag-and-drop';
import { TimeslotDragType } from '../../../../models/calendar';
import { Timeslot } from '../Timeslot';
import classNames from 'classnames';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { PostingPlanContext } from '../../../../providers/PostingPlanProvider';
// import { throttle } from 'lodash';
import { CSSTransition } from 'react-transition-group';
import { Identifier } from 'dnd-core';
import { useDidMount } from 'hooks/useDidMount';
import { OnboardingContext } from '../../../Onboarding/states/OnboardingProvider';
import { OnboardingStaticContent } from '../../../Onboarding/constants/content';
// import { PostingPlanHelpers } from '../postingPlanHelpers';
// import timeslotClasses from '../Timeslot/Timeslot.module.scss';

export type DraggableTimeslotWrapperViewProps = TimeslotMappedData & {
  //
  position: [number, number];
};

export type DragTypeProps = {
  isDragging: boolean;
  isDropped?: boolean;
  handlerId: Identifier | null;
};

export const DraggableTimeslotWrapperView = (props: DraggableTimeslotWrapperViewProps): JSX.Element => {
  const { source, setSource } = useContext(PostingPlanContext);
  const localRef = useRef<HTMLDivElement | null>(null);
  const { showOnboarding, state: onboardingState } = useContext(OnboardingContext);
  const { version } = onboardingState;
  const disableDelete = OnboardingStaticContent[`v${version}`].disableDelete.timeslots;

  // Animation settings fade in/out
  const [mount, setMount] = useState<boolean>(false);
  const nodeRef = useRef<HTMLDivElement>(null);
  // const [shouldRender, setShouldRender] = useState(true);
  // const [nodeHeight, setNodeHeight] = useState(0);

  useDidMount(() => {
    // nodeRef.current && setNodeHeight(nodeRef.current.offsetHeight);
    // we ned to setMount to true, since we wnat to trigger animation (fade) only when the component has been completely mounted.
    setMount(true);
    return () => setMount(false);
  });

  const { id, socialProfiles, colour, name, position, time, categoryId, onboardingContent } = props;
  const [{ isDragging }, dragRef, preview] = useDrag<TimeslotDragType, unknown, DragTypeProps>({
    type: DraggableTypesObject.TIMESLOT,
    item: {
      id,
      startPosition: position,
      categoryId,
      colour,
      name,
      socialProfiles,
      height: localRef.current?.offsetHeight || 0,
      width: localRef.current?.offsetWidth || 0,
      time,
      onboardingContent: onboardingContent && showOnboarding && disableDelete
    },

    collect: (itemMonitor: DragSourceMonitor<TimeslotDragType>) => ({
      isDragging: itemMonitor.isDragging(),
      handlerId: itemMonitor.getHandlerId()
    })
  });

  // Only renders timeslots when they are within the scrollable area.
  // useEffect(() => {
  //   // TODO is there a more API way to get this element rather than querySelector?
  //   const scrollableContent = document.querySelector('table[data-scrollable]')?.parentElement;
  //
  //   const listener = throttle(() => {
  //     const timeslotNode = nodeRef;
  //
  //     if (timeslotNode.current && scrollableContent) {
  //       const timeslotNodeTop = timeslotNode.current.getBoundingClientRect().top;
  //       const timeslotNodeBottom = timeslotNode.current.getBoundingClientRect().bottom;
  //       const buffer = 100;
  //
  //       // TODO check with team if these are appropriate properties to use.
  //       const topMax = scrollableContent.getBoundingClientRect().top;
  //       const bottomMax = window.innerHeight;
  //
  //       if (timeslotNodeBottom < topMax - buffer) {
  //         setShouldRender(false);
  //       } else if (timeslotNodeTop > bottomMax + buffer) {
  //         setShouldRender(false);
  //       } else {
  //         setShouldRender(true);
  //       }
  //     }
  //   }, 150);
  //
  //   scrollableContent?.addEventListener('scroll', listener);
  //   return () => {
  //     scrollableContent?.removeEventListener('scroll', listener);
  //   };
  // }, []);

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
    if (isDragging && JSON.stringify(source) !== JSON.stringify(position)) {
      setSource(position);
    }
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [preview, isDragging]);

  // if (!shouldRender) {
  //   // Current calculation code requires a <time> element, and the height to be accurate.
  //   return (
  //     <time
  //       style={{ height: nodeHeight + 'px' }}
  //       ref={nodeRef}
  //       className={timeslotClasses.Time}
  //       data-date={PostingPlanHelpers.getTime(props.day, props.time, props.timeFormat).time}
  //     />
  //   );
  // }

  const globalClasses = classNames(isDragging ? classes.IsDragging : classes.Item);

  return (
    <div
      ref={ref => {
        localRef.current = ref;
        dragRef(ref);
      }}
      aria-describedby={`draggable-timeslot-${position[0]}-${position[1]}`}
      className={globalClasses}>
      <CSSTransition in={mount} timeout={300} classNames={'fade'} nodeRef={nodeRef}>
        <div ref={nodeRef}>
          <Timeslot {...props} isListView={false} />
        </div>
      </CSSTransition>
    </div>
  );
};
